// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";
// import { Row, Col, Table, Button } from "react-bootstrap";
// import { useParams } from "react-router-dom";
// import { LinkContainer } from "react-router-bootstrap";
// import Loading from "../components/Loading";
// import Message from "../components/Message";
// import Paginate from "../components/Paginate";
// import { listProduct, deleteProduct } from "../redux/actions/productActions";

// const ProductListScreen = () => {
//   const [isAdmin, setIsAdmin] = useState(null);
//   const [loadingAdminCheck, setLoadingAdminCheck] = useState(true);
//   const [adminError, setAdminError] = useState(null);

//   let params = useParams();
//   const pageNumber = params.pageNumber;
//   const dispatch = useDispatch();

//   const productList = useSelector((state) => state.productList);
//   const { products, loading, error, page, pages } = productList;

//   const productDelete = useSelector((state) => state.productDelete);
//   const { loading: loadingDelete, success: successDelete, error: errorDelete } = productDelete;

//   useEffect(() => {
//     // Fetch user profile to verify admin status
//     const fetchUserProfile = async () => {
//       try {
//         const res = await fetch("/api/users/profile", {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).token : ""}`,
//           },
//         });
//         if (res.ok) {
//           const data = await res.json();
//           setIsAdmin(data.user.isAdmin);
//         } else {
//           setIsAdmin(false);
//           setAdminError("Not authorized");
//         }
//       } catch (err) {
//         setIsAdmin(false);
//         setAdminError("Error checking authorization");
//       } finally {
//         setLoadingAdminCheck(false);
//       }
//     };

//     fetchUserProfile();
//   }, []);

//   useEffect(() => {
//     if (isAdmin) {
//       dispatch(listProduct("", pageNumber));
//     }
//   }, [dispatch, successDelete, pageNumber, isAdmin]);

//   const deleteProductHandler = (id) => {
//     if (window.confirm("Are you sure?")) {
//       dispatch(deleteProduct(id));
//     }
//   };

//   if (loadingAdminCheck) return <Loading />;

//   if (!isAdmin) {
//     return <Message variant="danger">{adminError || "Not authorized to access this page."}</Message>;
//     // OR redirect:
//     // return <Navigate to="/" />;
//   }

//   return (
//     <>
//       <Row className="align-items-center">
//         <Col>
//           <h3>Products List</h3>
//         </Col>
//         <Col className="text-end">
//           <LinkContainer to="/admin/products/create">
//             <Button variant="primary">
//               <i className="fas fa-plus"></i> Create Product
//             </Button>
//           </LinkContainer>
//         </Col>
//       </Row>
//       {errorDelete && <Message variant="danger">{errorDelete}</Message>}
//       {loading ? (
//         <Loading />
//       ) : error ? (
//         <Message variant="danger">{error}</Message>
//       ) : (
//         <Row>
//           <Col>
//             {loadingDelete ? (
//               <Loading />
//             ) : (
//               <Table striped rounded="true" hover className="table-sm">
//                 <thead>
//                   <tr>
//                     <td>ID</td>
//                     <td>Name</td>
//                     <td>Category</td>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {products.map((product, index) => (
//                     <tr key={index}>
//                       <td>{product._id}</td>
//                       <td>{product.name}</td>
//                       <td>{product.category}</td>
//                       <td>
//                         <LinkContainer className="ml-1" to={`/admin/product/edit/${product._id}`}>
//                           <Button className="btn btn-sm" variant="primary">
//                             <i className="fas fa-edit"></i>
//                           </Button>
//                         </LinkContainer>
//                         <Button className="btn btn-sm" variant="danger" onClick={() => deleteProductHandler(product._id)}>
//                           <i className="fas fa-trash"></i>
//                         </Button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             )}
//           </Col>
//         </Row>
//       )}
//       <Paginate page={page} pages={pages} isAdmin={true} />
//     </>
//   );
// };

// export default ProductListScreen;

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Table, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import Loading from "../components/Loading";
import Message from "../components/Message";
import Paginate from "../components/Paginate";
import { listProduct, deleteProduct } from "../redux/actions/productActions";

const ProductListScreen = () => {
  const dispatch = useDispatch();
  const { pageNumber } = useParams(); // destructure directly

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const isAdmin = userInfo && userInfo.isAdmin;

  const productList = useSelector((state) => state.productList);
  const { products, loading, error, page, pages } = productList;

  const productDelete = useSelector((state) => state.productDelete);
  const { loading: loadingDelete, success: successDelete, error: errorDelete } = productDelete;

  useEffect(() => {
    if (isAdmin) {
      // Pass true for admin mode to call the admin API
      dispatch(listProduct("", pageNumber || 1, "", true));
    }
  }, [dispatch, successDelete, pageNumber, isAdmin]);

  const deleteProductHandler = (id) => {
    if (window.confirm("Are you sure?")) {
      dispatch(deleteProduct(id));
    }
  };

  if (!isAdmin) {
    return <Message variant="danger">Not authorized to access this page.</Message>;
  }

  return (
    <>
      <Row className="align-items-center mb-3">
        <Col>
          <h3>Products List</h3>
        </Col>
        <Col className="text-end">
          <LinkContainer to="/admin/products/create">
            <Button variant="primary">
              <i className="fas fa-plus"></i> Create Product
            </Button>
          </LinkContainer>
        </Col>
      </Row>

      {errorDelete && <Message variant="danger">{errorDelete}</Message>}

      {loading || loadingDelete ? (
        <Loading />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <>
          <Table striped hover responsive className="table-sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Category</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {products && products.length > 0 ? (
                products.map((product) => (
                  <tr key={product._id}>
                    <td>{product._id}</td>
                    <td>{product.name}</td>
                    <td>{product.category}</td>
                    <td>
                      <LinkContainer to={`/admin/product/edit/${product._id}`} >
                        <Button className="btn-sm" variant="primary">
                          <i className="fas fa-edit"></i>
                        </Button>
                      </LinkContainer>
                      <Button
                        className="btn-sm ms-2"
                        variant="danger"
                        onClick={() => deleteProductHandler(product._id)}
                      >
                        <i className="fas fa-trash"></i>
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No products found</td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination */}
          {pages > 1 && <Paginate page={page} pages={pages} isAdmin={true} />}
        </>
      )}
    </>
  );
};

export default ProductListScreen;
